import { EntityState } from '@reduxjs/toolkit'
import { z } from 'zod'

import { Gift } from '../types/gifts'

const KEY = 'cart/gifts-persist'

const KeyValueSchema = z.record(z.number())
type KeyValue = z.infer<typeof KeyValueSchema>

const transformGiftsEntityIntoKeyValuePair = (data: EntityState<Gift>) => {
	const transformedData: KeyValue = {}

	for (const productId in data.entities) {
		//@ts-ignore typescript can not infer the type
		transformedData[Number(productId)] = data.entities[productId].ID
	}

	return transformedData
}

interface GiftsLsService {
	set(data: EntityState<Gift>): void
	setSingle(productId: number, giftId: number): boolean
	get(): Record<number, number>
}

export const giftsLsService: GiftsLsService = {
	set(data: EntityState<Gift>) {
		const preparedData = transformGiftsEntityIntoKeyValuePair(data)

		return localStorage.setItem(KEY, JSON.stringify(preparedData))
	},
	setSingle(productId: number, giftId: number) {
		try {
			const raw = localStorage.getItem(KEY)
			const map = raw ? (JSON.parse(raw) as Record<number, number>) : {}
			map[productId] = giftId
			localStorage.setItem(KEY, JSON.stringify(map))
			return true
		} catch {
			return false
		}
	},
	get() {
		const lsData = localStorage.getItem(KEY)

		const gifts = z
			.string()
			.transform(value => {
				try {
					return JSON.parse(value)
				} catch {
					return null
				}
			})
			.pipe(KeyValueSchema)
			.safeParse(lsData)

		if (gifts.success) return gifts.data
		// Fallback: попытка мягко распарсить без схемы
		try {
			const raw = lsData ? JSON.parse(lsData) : {}
			if (raw && typeof raw === 'object') {
				const out: Record<number, number> = {}
				for (const k of Object.keys(raw)) {
					const pid = Number(k)
					const val = Number((raw as any)[k])
					if (!Number.isNaN(pid) && !Number.isNaN(val)) out[pid] = val
				}
				return out
			}
		} catch {}
		return {}
	}
}
